/* eslint-disable no-unreachable */
import React from "react";
import { data } from "../Object/data.js";
import { HiArrowNarrowRight } from "react-icons/hi";
import { Link } from "react-router-dom";

const Work = () => {
  return (
    <>
      <article
        aria-label="some work projects"
        name="Work"
        className="flex items-center w-screen md:w-10/12"
      >
        <div className="w-full p-3 py-10 mx-auto text-gray-200 sm:w-full sm:p-8 bg-slate-800/40 backdrop-blur-sm backdrop-brightness-50 backdrop-sepia">
          <section aria-label="work list">
            <div className="pb-8">
              <h2 className="inline text-4xl font-bold text-gray-300 border-b-4 rounded border-cyan-600">
                {"Work"}
              </h2>
              <p aria-label="ui sample project" className="py-6">
                Some UI's recently worked with
              </p>
            </div>

            {/* container for projects */}
            <div className="grid gap-6 sm:gap-7 md:gap-5 sm:grid-cols-2 md:grid-cols-3">
              {/* Gird Item */}
              {data.map((item) => {
                return item.id <= 4 ? (
                  <section aria-label={item.name} key={item.id}>
                    <figure
                      aria-label={item.name}
                      style={{ backgroundImage: `url(${item.image})` }}
                      className="container flex items-center justify-center mx-auto text-center rounded-md shadow-xl shadow-gray-900 group content-div "
                    >
                      {/* Hover effect for images */}
                      <hgroup className="duration-300 opacity-0 group-hover:opacity-100 ">
                        <h2 className="text-xl text-white font bold ">
                          {item.name}
                        </h2>
                        <div className="pt-8 text-center ">
                          {/* eslint-disable-next-line */}
                          <a
                            href={item.github}
                            id={item.name}
                            rel="exteranl noreferrer noopener"
                            title="github page"
                            target="_blank"
                          >
                            <button
                              type="button"
                              className="px-4 py-2 m-2 text-lg font-bold text-center text-gray-700 bg-white border-4 rounded-lg border-cyan-800"
                            >
                              Code
                            </button>
                          </a>
                          {/* eslint-disable-next-line */}
                          <Link to={item.live}>
                            <button
                              type="button"
                              className="px-4 py-2 m-2 text-lg font-bold text-center border-4 rounded-lg bg-cyan-800 border-cyan-800 text-gray-50"
                            >
                              View More
                            </button>
                          </Link>
                        </div>
                      </hgroup>
                    </figure>
                    <h2 className="py-1 text-lg font-bold underline underline-offset-4 decoration-cyan-600 sm:hidden">
                      {item.name}
                    </h2>
                  </section>
                ) : null;
              })}
            </div>
          </section>

          <section aria-label="more button" className="flex justify-end mt-6">
            <Link to="works">
              <button
                type="button"
                className="flex py-3 border-2 rounded-lg shadow-xl border-cyan-800 shadow-gray-900 hover:bg-cyan-800 group px-9"
              >
                View All
                <HiArrowNarrowRight
                  size={26}
                  aria-label="View more"
                  className="ml-3 duration-700 group-hover:animate-ping "
                />
              </button>
            </Link>
          </section>
        </div>
      </article>
    </>
  );
};

export default Work;
